<template>
  <div>
    <div v-if="assignment.totalErrorsCount">
      <div class="d-flex">
        <span class="pr-3">
          <AttachSourceFile />
          <FixErrors />
        </span>
        <InfoAlert class="ml-auto danger"> Please fix all fatal errors to proceed </InfoAlert>
      </div>
    </div>
    <div v-else>
      <div>
        <div v-if="status === OPEN">
          <Process />
        </div>
        <div v-else-if="status === VALIDATION_COMPLETE">
          <AttachSourceFile />
          <CreateReport />
        </div>
        <div v-else-if="status === REPORT_RELEASED">
          <ViewAdjacent :is-report-origin="isReportOrigin" />
          <AcceptReport />
          <RejectReport />
        </div>
        <div v-else-if="status === REPORT_ACCEPTED">
          <ViewAdjacent :is-report-origin="isReportOrigin" />
          <CreateLabels />
        </div>
        <div v-else-if="status === REPORT_DENIED">
          <ViewAdjacent :is-report-origin="isReportOrigin" />
          <Complete />
        </div>
        <div v-else-if="status === LABELS_RELEASED">
          <ViewAdjacent :is-report-origin="isReportOrigin" />
          <DownloadLabels />
          <DownloadDocuments />
          <Complete />
        </div>
        <div v-else-if="status === COMPLETE">
          <ViewAdjacent :is-report-origin="isReportOrigin" />
        </div>
      </div>
    </div>
  </div>
  <AttachSourceFileModal />
  <FixErrorsModal />
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import {
  OPEN,
  COMPLETE,
  REPORT_DENIED,
  REPORT_ACCEPTED,
  REPORT_RELEASED,
  LABELS_RELEASED,
  VALIDATION_COMPLETE,
} from '@/const/AssignmentStatuses'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import Process from '@/views/Components/Assignment/Actions/Buttons/Process.vue'
import Complete from '@/views/Components/Assignment/Actions/Buttons/Complete.vue'
import FixErrors from '@/views/Components/Assignment/Actions/Buttons/FixErrors.vue'
import InfoAlert from '@/views/Components/PageParts/InfoAlert.vue'
import AcceptReport from '@/views/Components/Assignment/Actions/Buttons/AcceptReport.vue'
import CreateLabels from '@/views/Components/Assignment/Actions/Buttons/CreateLabels.vue'
import CreateReport from '@/views/Components/Assignment/Actions/Buttons/CreateReport.vue'
import RejectReport from '@/views/Components/Assignment/Actions/Buttons/RejectReport.vue'
import ViewAdjacent from '@/views/Components/Assignment/Actions/Buttons/ViewAdjacent.vue'
import DownloadLabels from '@/views/Components/Assignment/Actions/Buttons/DownloadLabels.vue'
import FixErrorsModal from '@/views/Modals/Assignment/FixErrorsModal.vue'
import AttachSourceFile from '@/views/Components/Assignment/Actions/Buttons/AttachSourceFile.vue'
import DownloadDocuments from '@/views/Components/Assignment/Actions/Buttons/DownloadDocuments.vue'
import AttachSourceFileModal from '@/views/Modals/Assignment/AttachSourceFileModal.vue'

export default defineComponent({
  name: 'AssignmentActions',
  components: {
    Process,
    Complete,
    FixErrors,
    ViewAdjacent,
    DownloadLabels,
    DownloadDocuments,
    AttachSourceFile,
    AcceptReport,
    CreateReport,
    CreateLabels,
    RejectReport,
    InfoAlert,
    FixErrorsModal,
    AttachSourceFileModal,
  },
  props: {
    origin: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const assignmentSummaryStore = useAssignmentSummaryStore()

    const assignment = computed(() => assignmentSummaryStore.assignment)
    const status = computed(() => assignmentSummaryStore.assignmentStatus)

    return {
      status,
      assignment,
      isReportOrigin: props.origin === 'report',
      VALIDATION_COMPLETE,
      REPORT_RELEASED,
      REPORT_ACCEPTED,
      REPORT_DENIED,
      LABELS_RELEASED,
      COMPLETE,
      OPEN,
    }
  },
})
</script>
